 goog.provide('el8.practicedata.appts');
goog.provide('el8.practicedata.model.appt');
goog.provide('el8.practicedata.model.apptStatus');
goog.provide('el8.practicedata.model.apptReminder');

goog.require('el8.data.apptTypes');
goog.require('el8.data.apptRooms');
goog.require('el8.data.practiceUsers');
goog.require('el8.data.model.copayPayment');
goog.require('el8.model.base');
goog.require('el8.ptdata.patients');
goog.require('el8.service.tz');
goog.require('el8.service.urls');

el8.practicedata.appts = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.appt_type) {
            el8.data.apptTypes.create(spec.appt_type);
        }
        if (spec.room) {
            el8.data.apptRooms.create(spec.room);
        }
        this.parent.populate.call(this, spec);
    };

    _class.addIntProperty('patientId', true);
    _class.addStringProperty('patientName');
    _class.addStringProperty('patientPhone');
    _class.addBoolean('patientDeleted');
    _class.addDate('patientDob');

    _class.addIntProperty('physicianUserId', true);

    _class.addDateTime('apptTime', true);
    _class.addIntProperty('duration', true);
    _class.addIntProperty('apptTypeId', true);

    _class.addStringProperty('description', true);

    _class.addStringProperty('status', true);
    _class.addStringProperty('statusNote', true);
    _class.addIntProperty('roomId', true);
    _class.addStringProperty('displayStatus');
    _class.addDateTime('statusTime');

    _class.addModelProperty('copayCollected', el8.data.model.copayPayment, true);

    _class.addModelProperty('primaryInsurance', el8.ptdata.model.ptInsurance, true);
    _class.addModelProperty('secondaryInsurance', el8.ptdata.model.ptInsurance, true);

    _class.addStringProperty('billingNote', true);
    _class.addStringProperty('referringProvider', true);
    _class.addStringProperty('referringProviderState', true);

    _class.addStringProperty('telehealthInstructions', true);
    _class.addProperty('patientCanReceiveTelehealthInstructions', true);

    // For when we get an appointment slot (shouldn't be appointment) that is
    // part of the recurring appointment slot
    _class.addIntProperty('recurringEventGroupId');
    _class.addIntProperty('recurringEventScheduleId');
    _class.addBoolean('vip', true);

    /**
     * These fields are simply for saving timeblocks for when they
     * get split off of a recurring event
     */
    _class.addIntProperty('scheduleId');
    _class.addDate('replacedApptDate');   // date in the schedule getting replaced
    _class.addDate('nextApptDate');       // date schedule should start again at

    _class.addIntProperty('timeSlotType');
    _class.addIntProperty('timeSlotStatus', true);

    _class.prototype.getApptType = function() {
        return el8.data.apptTypes.getByIdIncludingDeleted(this.getApptTypeId());
    };
    _class.prototype.getEndApptTime = function() {
        var endApptTime = el8.service.tz.newTzDateTime(this.getApptTime());
        return endApptTime.addMinutes(this.getDuration());
    };
    _class.prototype.getStartTime = function() {
        return el8.service.tz.newTzTime(
                this.getApptTime().getHours(), this.getApptTime().getMinutes(),
                this.getApptTime().getSeconds(), this.getApptTime().getMilliseconds());
    };
    _class.prototype.getEndTime = function() {
        // NOTE: This implementation allows us to have the idea of 24:00
        return this.getStartTime().addMinutes(this.getDuration());
    };
    _class.prototype.isAllPhysicians = function() {
        return !this.getPhysicianUserId();
    };
    _class.prototype.isTimeBlock = function() {
        // used to only check that there's no patient: return !Boolean(this.getPatientId()) &&
        return this.getTimeSlotType() === 2;
    };
    _class.prototype.isAppointmentSlot = function() {
        return this.getTimeSlotType() === 3;
    };
    _class.prototype.isAppointment = function() {
        // special case, if it's an appointment slot with a patient id assigned,
        // then it's both appt slot and appt
        return this.getTimeSlotType() === 1 || (this.getTimeSlotType() === 3 && this.getPatientId());
    }
    _class.prototype.isEvent = function() {
        return this.getTimeSlotType() === 2;
    }
    _class.prototype.isOpenSlot = function() {
        // returns true if it's a slot & has no pt
        return this.isAppointmentSlot() && !this.getPatientId();
    }
    _class.prototype.isFilledSlot = function() {
        // returns true if it's a slot & has pt.
        return this.isAppointmentSlot() && this.getPatientId();
    }
    _class.prototype.isAppointmentSlotAvailableForSelfSchedule = function() {
        return this.isAppointmentSlot() && this.getTimeSlotStatus() !== 1;
    }
    _class.prototype.getTimeSlotTypeStr = function() {
        var slotType = this.getTimeSlotType();
        if(slotType === 1) {
            return 'appointment';
        } else if (slotType === 2) {
            return 'event';
        } else if (slotType === 3) {
            return 'appointment_slot';
        } else {
            return 'unknown';
        }
    };
    _class.prototype.isSlotVisible = function() {
        // returns false if time_slot_status is 1, otherwise 0
        return this.getTimeSlotStatus() !== 1;
    };
    _class.prototype.getPhysicianUserFullName = function() {
        if (this.getPhysicianUserId()) {
            var user = el8.data.practiceUsers.getById(this.getPhysicianUserId());
            return user ? user.getFullName() : '';
        } else {
            return 'all physicians';
        }
    };

    _class.prototype.launchPatient = function() {
        // Display visit note form if the appt is today.
        var destination = '/patient/' + this.getPatientId();
        var today = el8.service.tz.today();
        if (today.getYear() === this.getApptTime().getYear() &&
            today.getMonth() === this.getApptTime().getMonth() &&
            today.getDay() === this.getApptTime().getDay()) {
            destination += "/vnote/";
        }

        var queryParams = [];

        if (this.getApptTypeId() && this.getApptType().getVisitNoteTypeId()) {
            // open the visit note with a particular type
            queryParams.push("vnote-type=" + this.getApptType().getVisitNoteTypeId());
        }
        var queryParamsString = queryParams.join('&');

        if (queryParamsString) {
          destination += "?" + queryParamsString;
        }

        window.open(destination);
    };

    _class.prototype.asSoyMap = function() {
        var m = this.parent.asSoyMap.call(this);

        m['isTimeBlock'] = this.isTimeBlock();

        m['startTime'] = this.getStartTime().asTimeString();
        m['endTime'] = this.getEndTime().asTimeString();

        m['startTimeShort'] = this.getStartTime().asShortTimeString();
        m['endTimeShort'] = this.getEndTime().asShortTimeString();

        m['apptDateString'] = this.getApptTime().asString();
        m['apptDatedisplay'] = this.getApptTime().asStringFormat('DDD, mmm ddd, yyyy');

        m['apptType'] = this.getApptTypeId() ?
            el8.data.apptTypes.getByIdIncludingDeleted(this.getApptTypeId()).asSoyMap() : null;

        var roomId = this.getRoomId();
        var room = roomId ? el8.data.apptRooms.getByIdIncludingDeleted(roomId) : null;
        m['room'] = room ? room.asSoyMap() : null;

        m['physicianName'] = this.getPhysicianUserFullName();

        return m;
    };
    _class.prototype.asMap = function() {
        return el8_Entity.prototype.asMap.call(this, true);
    };

    el8.practicedata.model.appt = function(spec) { return new _class(spec); };

    var that = new el8_EntitySet({
        model: el8.practicedata.model.appt,
        urlFn: function(id) { return el8.service.urls.get('appointment', [id]); },
        saveFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            var map = item.asMap();
            if (item.getScheduleId()) {
                map['schedule_id'] = item.getScheduleId();
                map['replaced_appt_date'] = item.getReplacedApptDate() ?
                    item.getReplacedApptDate().asString() : null;
                map['next_appt_date'] = item.getNextApptDate() ?
                    item.getNextApptDate().asString() : null;
            }
            if (map['copay_collected']) {
                // Flatten out the copay model and send up just the amount.
                // The server will take care of figuring out whether to
                // update the existing payment or make a new one
                if (map['copay_collected'].hasOwnProperty('amount')) {
                    map['copay_collected'] = map['copay_collected']['amount'];
                }
            }
            var url;
            if (item.isTimeBlock()) { url = el8.service.urls.get('postTimeBlock', item.getId() ? [item.getId()] : null); }
            else if (item.isAppointment()) { url = el8.service.urls.get('appointment', item.getId() ? [item.getId()] : null); }
            else if (item.isAppointmentSlot()) { url = el8.service.urls.get('appointmentSlot', item.getId() ? [item.getId()] : null); }
            else { url = el8.service.urls.get('appointment', item.getId() ? [item.getId()] : null); }

            $.el8_ajax({
                type: 'POST',
                url: url,
                data: JSON.stringify(map),
                async: opts.async,
                success: function(data) {
                    if (data['new_schedule'] || data['existing_schedule'] || data['block']) {
                        el8.practicedata.recurringEventSchedules.create(data['existing_schedule']);
                        item.populate(data['block']);
                        if (data['new_schedule']) {
                            el8.practicedata.recurringEventSchedules.create(data['new_schedule']);
                        }
                    } else {
                        item.populate(data);
                    }
                    if (successCb) { successCb(data); }
                    that.trigger('LOCAL_UPDATE', item, opts.oldItem);
                },
                error: errorCb
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            opts = opts || {};
            $.el8_ajax({
                type: 'DELETE',
                url: item.isTimeBlock() ?
                    el8.service.urls.get('postTimeBlock', [item.getId()]) :
                    el8.service.urls.get('appointment', [item.getId()]),
                async: opts.async,
                success: function(data) {
                    if (successCb) { successCb(data); }
                    that.trigger('LOCAL_DELETE', item);
                },
                error: errorCb
            });
        }
    });

    that.saveNewStatus = function(appt, opts, successCb) {
        opts = opts || {};
        if (appt.isTimeBlock()) { return; }
        var m = {};
        m['status'] = opts.statusCode;
        m['status_note'] = opts.statusNote;
        m['room_id'] = opts.roomId;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('apptStatuses', [appt.getId()]),
            data: JSON.stringify(m),
            success: function(data) {
                appt.populate(data);
                that.trigger('LOCAL_UPDATE', appt);
                if (successCb) { successCb(appt); }
            }
        });
    };

    that.getByPhysicianUserIdAndDate = function(physicianUserId, _date) {
        var all = that.all().filter(function(a) {
            return el8.util.datecompare.isSameDay(a.getApptTime(), _date) &&
                (!a.getPhysicianUserId() ||
                    (a.getPhysicianUserId() === physicianUserId));
        });
        return all;
    };


    // An apptStatus class, which we won't use to hold status info for an appointment
    // but can be useful when we have a group of statuses to render for an appointment
    var _statusClass = function(spec) { this.populate(spec); };

    _statusClass.inheritsFrom(el8_Entity);
    _statusClass.addStringProperty('status');
    _statusClass.addStringProperty('statusNote');
    _statusClass.addIntProperty('roomId');
    _statusClass.addStringProperty('displayStatus');
    _statusClass.addIntProperty('patientId');
    _statusClass.addDateTime('statusTime');
    _statusClass.addIntProperty('createUserId');

    _statusClass.prototype.asSoyMap = function() {
        var m = this.parent.asSoyMap.call(this);

        var createUser = el8.data.practiceUsers.getById(this.getCreateUserId());

        if (createUser) {
          m['createUserName'] = this.getPatientId() ? 'Patient' : createUser.getFullName();
        } else {
          m['createUserName'] = '';
        }


        m['room'] = this.getRoomId() ?
            el8.data.apptRooms.getByIdIncludingDeleted(this.getRoomId()).asSoyMap() : null;

        return m;
    };

    el8.practicedata.model.apptStatus = function(spec) { return new _statusClass(spec); };


    // same purpose as the _statusClass above
    var _reminderClass = function(spec) { this.populate(spec); };
    _reminderClass.inheritsFrom(el8_Entity);

    _reminderClass.addIntProperty('appointmentId');
    _reminderClass.addStringProperty('reminderType');
    _reminderClass.addStringProperty('status');
    _reminderClass.addStringProperty('failureReason');
    _reminderClass.addDateTime('reminderTime');
    _reminderClass.addStringProperty('sentTo');
    _reminderClass.addStringProperty('displayText');

    el8.practicedata.model.apptReminder = function(spec) { return new _reminderClass(spec); };


    return that;

})();
